(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-detail-tabs"] && !Shopify.designMode) return;
  try {
    class YelsooProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleClick);
        tab.addEventListener('keydown', this.handleKeydown);
      });
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.handleClick);
        tab.removeEventListener('keydown', this.handleKeydown);
      });
    }

    handleClick = (event) => this.selectTab(event.currentTarget);

    handleKeydown = (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      this.selectTab(this.tabs[nextIndex]);
      this.tabs[nextIndex].focus();
    };

    selectTab(selected) {
      const shouldOpen = selected.getAttribute('aria-expanded') !== 'true';
      this.tabs.forEach((tab) => {
        const isSelected = tab === selected && shouldOpen;
        tab.setAttribute('aria-selected', String(isSelected));
        tab.setAttribute('aria-expanded', String(isSelected));
        tab.tabIndex = tab === selected ? 0 : -1;
        const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !isSelected;
      });
    }
  }

  if (!customElements.get('yelsoo-product-tabs')) customElements.define('yelsoo-product-tabs', YelsooProductTabs);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-fit-tools"] && !Shopify.designMode) return;
  try {
    class YelsooFitTools extends HTMLElement {
    connectedCallback() {
      this.previousOverflow = '';
      this.querySelectorAll('[data-open-dialog]').forEach((button) => button.addEventListener('click', this.openDialog));
      this.querySelectorAll('[data-close-dialog]').forEach((button) => button.addEventListener('click', this.closeDialog));
      this.querySelectorAll('dialog').forEach((dialog) => {
        dialog.addEventListener('click', this.closeOnBackdrop);
        dialog.addEventListener('close', this.restoreScroll);
      });
      this.querySelectorAll('[data-unit-control] button').forEach((button) => button.addEventListener('click', this.toggleInputUnit));
      this.querySelector('[data-guide-units] button')?.addEventListener('click', this.toggleGuideUnit);
      this.querySelectorAll('.yelsoo-fit-tools__guide-tabs [role="tab"]').forEach((tab) => tab.addEventListener('click', this.selectGuideTab));
      this.querySelector('[data-finder-form]')?.addEventListener('input', this.updateSubmitState);
      this.querySelector('[data-finder-form]')?.addEventListener('change', this.updateSubmitState);
      this.querySelector('[data-finder-form]')?.addEventListener('submit', this.submitFinder);
      this.querySelector('[data-how-toggle]')?.addEventListener('click', this.toggleHowCopy);
    }

    openDialog = (event) => {
      const dialog = this.querySelector(`[data-dialog="${event.currentTarget.dataset.openDialog}"]`);
      if (!dialog) return;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    };

    closeDialog = (event) => event.currentTarget.closest('dialog')?.close();
    closeOnBackdrop = (event) => { if (event.target === event.currentTarget) event.currentTarget.close(); };
    restoreScroll = () => { document.documentElement.style.overflow = this.previousOverflow; };

    toggleInputUnit = (event) => {
      const control = event.currentTarget.closest('[data-unit-control]');
      const nextMetric = event.currentTarget.getAttribute('aria-checked') !== 'true';
      event.currentTarget.setAttribute('aria-checked', String(nextMetric));
      control.querySelectorAll('[data-unit-label]').forEach((label) => label.classList.toggle('is-active', label.dataset.unitLabel === (nextMetric ? 'metric' : 'imperial')));
      const isHeight = control.dataset.unitControl === 'height';
      const input = this.querySelector(isHeight ? '[data-height-input]' : '[data-weight-input]');
      if (input.value) {
        const value = Number(input.value);
        const converted = isHeight ? nextMetric ? value * 30.48 : value / 30.48 : nextMetric ? value * 0.453592 : value / 0.453592;
        input.value = converted.toFixed(1);
      }
      input.placeholder = isHeight ? nextMetric ? 'cm' : 'ft' : nextMetric ? 'kg' : 'lbs';
    };

    toggleGuideUnit = (event) => {
      const nextMetric = event.currentTarget.getAttribute('aria-checked') !== 'true';
      event.currentTarget.setAttribute('aria-checked', String(nextMetric));
      const labels = event.currentTarget.parentElement.querySelectorAll(':scope > span');
      labels[0]?.classList.toggle('is-active', !nextMetric);
      labels[1]?.classList.toggle('is-active', nextMetric);
      this.querySelectorAll('[data-measurement]').forEach((cell) => {
        const inches = cell.dataset.measurement;
        cell.textContent = nextMetric ? inches.split(' - ').map((value) => (Number(value) * 2.54).toFixed(1)).join(' - ') : inches;
      });
    };

    selectGuideTab = (event) => {
      const selected = event.currentTarget;
      this.querySelectorAll('.yelsoo-fit-tools__guide-tabs [role="tab"]').forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !active;
      });
    };

    updateSubmitState = () => {
      const form = this.querySelector('[data-finder-form]');
      const submit = form?.querySelector('[type="submit"]');
      if (submit) submit.disabled = !form.checkValidity();
    };

    submitFinder = (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const heightMetric = this.querySelector('[data-unit-control="height"] button').getAttribute('aria-checked') === 'true';
      const weightMetric = this.querySelector('[data-unit-control="weight"] button').getAttribute('aria-checked') === 'true';
      const height = Number(data.get('height')) * (heightMetric ? 1 : 30.48);
      const weight = Number(data.get('weight')) * (weightMetric ? 1 : 0.453592);
      const band = Number(data.get('band'));
      const embeddedSizes = JSON.parse(this.querySelector('[data-size-options]')?.textContent || '[]');
      const sizes = embeddedSizes.length ? embeddedSizes : ['XS', 'S', 'M', 'L', 'XL', '2XL'];
      let index = weight < 50 ? 0 : weight < 62 ? 1 : weight < 75 ? 2 : weight < 88 ? 3 : weight < 103 ? 4 : 5;
      if (height >= 188 || band >= 42) index += 1;
      if (height <= 158 && band <= 32) index -= 1;
      index = Math.max(0, Math.min(sizes.length - 1, index));
      this.querySelector('[data-size-result]').textContent = sizes[index];
      this.querySelector('.yelsoo-fit-tools__result').hidden = false;
    };

    toggleHowCopy = () => {
      const copy = this.querySelector('[data-how-copy]');
      copy.hidden = !copy.hidden;
    };
  }

  if (!customElements.get('yelsoo-fit-tools')) customElements.define('yelsoo-fit-tools', YelsooFitTools);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-social-offers"] && !Shopify.designMode) return;
  try {
    class YelsooCodeCopy extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-copy-code]');
      if (!this.button || this.button.dataset.copyReady === 'true') return;

      this.label = this.button.querySelector('[data-copy-label]');
      this.defaultLabel = this.label?.textContent;
      this.button.dataset.copyReady = 'true';
      this.button.addEventListener('click', () => this.copyCode());
    }

    async copyCode() {
      const code = this.button.dataset.copyCode;
      let copied = false;

      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(code);
          copied = true;
        } catch (error) {
          copied = false;
        }
      }

      if (!copied) copied = this.fallbackCopy(code);
      if (!copied || !this.label) return;

      window.clearTimeout(this.resetTimer);
      this.label.textContent = this.button.dataset.copySuccess;
      this.resetTimer = window.setTimeout(() => {
        this.label.textContent = this.defaultLabel;
      }, 1800);
    }

    fallbackCopy(code) {
      const textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      const copied = document.execCommand('copy');
      textarea.remove();
      return copied;
    }
  }

  if (!customElements.get('yelsoo-code-copy')) {
    customElements.define('yelsoo-code-copy', YelsooCodeCopy);
  }
  } catch(e) { console.error(e); }
})();

})();
